/**
 * Tenant descriptor for the two brands built from this codebase.
 *
 * CommonJS on purpose: `vue.config.js` (Node) reads it at build time and
 * app code reads it through webpack's CJS interop. Everything here is
 * compile-time — the DentCloud bundle never sees The Dentistry values.
 *
 * Only chrome/accent metadata lives here. Semantic status colours
 * (success / danger / warning / info) are deliberately not tenant-scoped.
 */
const CI_TENANT_KEY = "tantatat";

// This repository is the tantatat fork, so The Dentistry is the default.
// DentCloud builds opt in explicitly with VUE_APP_TENANT=dentcloud.
const DEFAULT_TENANT_KEY = CI_TENANT_KEY;

const GOOGLE_FONTS_CI =
  "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Anuphan:wght@400;500;600&display=swap";

const TENANTS = {
  dentcloud: {
    key: "dentcloud",
    isCi: false,
    title: "DentCloud",
    shortName: "DentCloud",
    loadingText: "DentCloud Loading Resources...",
    themeColor: "#1d5d8e",
    backgroundColor: "#f8f9fa",
    iconDir: "icons",
    faviconHref: "favicon.ico",
    fontsHref: null,
  },
  [CI_TENANT_KEY]: {
    key: CI_TENANT_KEY,
    isCi: true,
    title: "The Dentistry",
    shortName: "TheDentistry",
    loadingText: "The Dentistry Loading Resources...",
    themeColor: "#5b6a86", // CI Dark Blue
    backgroundColor: "#ffffff",
    iconDir: "icons/tantatat",
    faviconHref: "icons/tantatat/favicon-32.png",
    fontsHref: GOOGLE_FONTS_CI,
  },
};

/**
 * @param {object} [env] usually `process.env`
 * @returns {object} a frozen tenant descriptor; unknown or missing values
 *   fall back to the repository default (tantatat / The Dentistry).
 */
function resolveTenant(env) {
  const key = env && typeof env.VUE_APP_TENANT === "string" ? env.VUE_APP_TENANT.trim() : "";
  const tenant = TENANTS[key] || TENANTS[DEFAULT_TENANT_KEY];
  return Object.freeze({ ...tenant });
}

module.exports = { resolveTenant, CI_TENANT_KEY, DEFAULT_TENANT_KEY };
